import {useLocation} from "react-router-dom"

import {BOTNAME, SPONSORNAME} from "@/constants"

export const useBotConfig = () => {
    const location = useLocation()
    const queryString = location.search
    const searchParams = new URLSearchParams(queryString)

    const cfg = {
        bot: BOTNAME, //searchParams.get("bot"),
        site: searchParams.get("site"),
        territory: searchParams.get("territory"),
        currency: searchParams.get("currency"),
        retailer: searchParams.get("retailer"),
        brand: searchParams.get("brand"),
        page: searchParams.get("page"),
        products: searchParams.get("products"),
        template: searchParams.get("template"),
        tabs: searchParams.get("tabs"),
        sponsor: SPONSORNAME, // searchParams.get("sponsor"),
    }

    return {cfg}
}
